import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';
import { useAuth } from 'context/AuthContext';
import { QuizType, finishQuiz, getQuizQuestions, sendQuestions, startQuiz, verifyQuiz } from 'services/quiz.service';
import FeedbackImg from '../../assets/img/comportamento/bg-feedback-moedas.png';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { actionLog } from 'services/actionlog.service';

interface MatrizProps {
  onClose: () => void;
  setQuizAnswered: () => void;
}

const quizId = 'rules';
const actionId = 'answer_quiz';

export default function Quiz({ onClose, setQuizAnswered }: MatrizProps) {
  const { userInfo, refreshUser } = useAuth();

  const [step, setStep] = useState(0);
  const [stepQuiz, setStepQuiz] = useState(0);
  const [quizLogId, setQuizLogId] = useState<string>('');
  const [questions, setQuestions] = useState<[QuizType]>();
  const [answers, setAnswers] = useState<any>([]);
  const [result, setResult] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [answerItem, setAnswerItem] = useState<any>([]);

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      if (!!userInfo?.chave) {
        const data = await startQuiz(userInfo.chave, quizId);
        setQuizLogId(data.log._id);
        const resp = await getQuizQuestions(quizId);

        const _answers: any = [];
        const _answerItem: any = [];

        resp?.forEach((e: any, index) => {
          if (e.log) {
            _answers[index] = e.log.answer[0];
            _answerItem[index] = e.log.extra.correct;
          }
        });

        setAnswerItem(_answerItem);
        setAnswers(_answers);

        setQuestions(resp);

        setLoading(false);
      }
    }

    async function isQuizDone() {
      const data = await verifyQuiz(quizId);
      if (data?.length > 0) {
        setStep(2);
      }
      setLoading(false);
    }

    if (userInfo?.chave && step === 1) {
      loadData();
    } else if (userInfo?.chave && step === 0) {
      isQuizDone();
    }
  }, [userInfo, step]);

  const handleChange = (index: number, e: any) => {
    const newAnswers = [...answers];
    newAnswers[index] = e.target.value;
    setAnswers(newAnswers);

    sendQuestion(index, newAnswers[index]);
  };

  async function sendQuestion(index: number, answer: any) {
    if (!userInfo?.chave) return;

    const payload = [
      {
        player: userInfo.chave,
        question: questions?.[index]._id,
        answer: [answer],
        quiz: quizId,
        quiz_log: quizLogId,
        extra: {
          correct: null,
        },
      },
    ];

    const _question = await sendQuestions(payload);
    if (_question?.registered?.[0]?.log?.extra?.correct) {
      const newAnswers = [...answerItem];
      newAnswers[index] = _question?.registered?.[0]?.log?.extra?.correct;
      setAnswerItem(newAnswers);
    }
  }

  async function sendQuiz() {
    if (!userInfo?.chave) return;
    setLoading(true);

    const resp = await finishQuiz(quizLogId);

    // await actionLog(userInfo?.chave, actionId, {
    //   quizLog: quizLogId,
    //   answered: true,
    // });

    setQuizAnswered();
    setResult(resp);
    setStep(2);

    refreshUser();
    setLoading(false);
  }

  function getText() {
    const value = Number(result?.log?.grade?.toFixed(1));
    if (value <= 2.8) {
      return {
        text: 'Não Bonificar',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que talvez essa
            entrega <br />
            <br /> <b>não tenha atendido às expectativas para bonificação.</b>.
          </p>
        ),
      };
    } else if (value > 2.8 && value < 4) {
      return {
        text: 'Passível de bonificação',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que a entrega <br />
            <br /> pode ser <b>bonificada</b>.
          </p>
        ),
      };
    } else if (value >= 4) {
      return {
        text: 'Passível de bonificação e promoção',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que a entrega <br />
            <br /> pode ser <b>bonificada</b> e até mesmo <b>promovida</b>.
          </p>
        ),
      };
    }
  }

  return (
    <div className="rb-modal-overlay rb-modal-overlay--top">
      <div className="rb-modal rb-modal--xl">
        <button
          className="rb-modal__close"
          aria-label="Fechar"
          disabled={loading}
          onClick={() => (!loading ? onClose() : null)}
        >
          <IoIosClose size={26} />
        </button>

        {!!loading && (
          <div className="space-y-3 w-full md:w-[555px]">
            <>
              <ArticlePlaceholder />
              <ArticlePlaceholder />
              <ArticlePlaceholder />
              <ArticlePlaceholder />
            </>
          </div>
        )}

        {step === 0 && !loading && (
          <div className="mx-auto w-full md:w-[556px]">
            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Quiz Regras do Programa</h1>
            </div>

            <p className="rb-modal__text text-center">
              Selecionamos perguntas com as Regras do Reconheça BRB. Responda cada uma delas com base no seu entendimento.
            </p>

            <div className="rb-modal__actions">
              <button className="rb-btn-primary" onClick={() => setStep(1)}>
                Iniciar quiz
              </button>
            </div>
          </div>
        )}

        {step === 1 && !loading && (
          <div className="space-y-8">
            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Quiz Regras do Programa</h1>
            </div>

            <div className="relative flex flex-row items-center justify-around mx-4">
              <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-[var(--color-border-light)]"></div>
              {questions?.map((e, index) => (
                <div
                  className={`${
                    stepQuiz === index
                      ? 'bg-[var(--blue-primary)] text-white ring-[var(--blue-primary)]'
                      : 'bg-white text-[var(--color-text-muted)] ring-[var(--color-border-light)]'
                  } text-xs font-semibold relative ring-1 rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                >
                  {index + 1}
                </div>
              ))}
            </div>

            <div className="mx-4">
              <p className="rb-modal__text">{questions?.[stepQuiz]?.question}</p>
            </div>

            <div className="rounded-lg bg-[var(--gray-100)] p-4 space-y-4">
              {questions?.[stepQuiz]?.choices.map(choice => (
                <div key={choice.label} className="radio-button">
                  <input
                    type="radio"
                    className="radio-button-input "
                    name={`${stepQuiz}`}
                    id={choice.label}
                    value={choice.answer}
                    onChange={(e: any) => handleChange(stepQuiz, e)}
                    checked={answers[stepQuiz] === choice.answer}
                    disabled={!!answers[stepQuiz] && answers[stepQuiz] !== choice.answer}
                  />
                  <label
                    htmlFor={choice.label}
                    className={`${!!answerItem[stepQuiz] && answerItem[stepQuiz] === choice.answer ? 'correct-radio' : ''}
                    ${
                      !!answerItem[stepQuiz] && answerItem[stepQuiz] !== choice.answer && answers[stepQuiz] === choice.answer
                        ? 'wrong-radio'
                        : ''
                    }
                    ${
                      !!answers[stepQuiz] && answers[stepQuiz] !== choice.answer ? 'disabled-radio' : ''
                    } radio-button-label text-base`}
                  >
                    {choice.label}
                  </label>
                </div>
              ))}
            </div>

            <div className="rb-modal__actions">
              {stepQuiz > 0 && (
                <button className="rb-btn-ghost" onClick={() => setStepQuiz(stepQuiz - 1)}>
                  Voltar
                </button>
              )}
              <button
                className="rb-btn-primary"
                onClick={() => {
                  if (questions && stepQuiz < questions?.length - 1) {
                    setStepQuiz(stepQuiz + 1);
                  } else {
                    sendQuiz();
                  }
                }}
                disabled={!answers[stepQuiz]}
              >
                Continuar
              </button>
            </div>
          </div>
        )}

        {step === 2 && !loading && (
          <div className="text-center mx-auto w-full md:w-[566px]">
            <img className="h-[155px] mx-auto mb-6" src={FeedbackImg} alt="Imagem de feedback" />

            <p className="rb-modal__text text-center">Quiz Regras do Programa:</p>
            <p className="rb-modal__title text-center">Concluído!</p>
          </div>
        )}
      </div>
    </div>
  );
}
